@let questionResponse = getSignal('question')();
@let answerResponse = getSignal('answer')();

<mat-expansion-panel class="faq-panel" hideToggle="false">
    <mat-expansion-panel-header class="faq-header">
    <mat-panel-title>
        @if (questionResponse.success) {
            <div class="left-align">
                <app-editable-text [customClass]="'custom-title-medium'" [elemId]="questionResponse.payload">
                </app-editable-text>
            </div>     
        }
    </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- <div class="faq-answer custom-body-medium" [innerHTML]="faq.answer"></div> -->
        @if (answerResponse.success) {
        <div class="left-align">
            <app-editable-text [customClass]="'custom-body-medium'" [elemId]="answerResponse.payload">
            </app-editable-text>
        </div>
    }
</mat-expansion-panel>

